var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container swiper-container swiper-container--home",
      class: [
        { "d-none d-md-block": !_vm.mobileSlider && !_vm.isShopbuilder },
        { "d-md-none": _vm.mobileSlider && !_vm.isShopbuilder },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.slides, function (slide, index) {
          return _c(
            "div",
            { staticClass: "swiper-slide home-slider__swiper-slide" },
            [
              slide.type === "image" &&
              (slide.gridType === "row" || slide.gridType === "grid")
                ? [
                    slide.gridType === "row"
                      ? _c("div", { staticClass: "home-slider__row-layout" }, [
                          _c(
                            "a",
                            { attrs: { href: slide.url } },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class": "img-cover img-fluid",
                                  "image-url": slide.imageUrl,
                                  "fallback-url": slide.imageUrl,
                                  alt: slide.imageAltText,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: slide.url2 } },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class": "img-cover img-fluid",
                                  "image-url": slide.imagePath2,
                                  "fallback-url": slide.imagePath2,
                                  alt: slide.imageAltText,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: slide.url3 } },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class": "img-cover img-fluid",
                                  "image-url": slide.imagePath3,
                                  "fallback-url": slide.imagePath3,
                                  alt: slide.imageAltText,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "home-slider__grid-layout" }, [
                          _c("div", [
                            _c(
                              "a",
                              { attrs: { href: slide.url } },
                              [
                                _c("lazy-img", {
                                  attrs: {
                                    "picture-class": "img-cover img-fluid",
                                    "image-url": slide.imageUrl,
                                    "fallback-url": slide.imageUrl,
                                    alt: slide.imageAltText,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              { attrs: { href: slide.url2 } },
                              [
                                _c("lazy-img", {
                                  attrs: {
                                    "picture-class": "img-cover img-fluid",
                                    "image-url": slide.imagePath2,
                                    "fallback-url": slide.imagePath2,
                                    alt: slide.imageAltText,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: slide.url3 } },
                            [
                              _c("lazy-img", {
                                attrs: {
                                  "picture-class": "img-cover img-fluid",
                                  "image-url": slide.imagePath3,
                                  "fallback-url": slide.imagePath3,
                                  alt: slide.imageAltText,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                  ]
                : _c(
                    "a",
                    {
                      attrs: {
                        href: slide.url,
                        target: slide.openInNewTab ? "_blank" : "_self",
                      },
                    },
                    [
                      slide.type === "image"
                        ? [
                            index === 1
                              ? _c("img", {
                                  staticClass: "img-cover img-fluid",
                                  attrs: {
                                    src: slide.imageUrl,
                                    alt: slide.imageAltText,
                                  },
                                })
                              : _c("lazy-img", {
                                  attrs: {
                                    "picture-class": "img-cover img-fluid",
                                    "image-url": slide.imageUrl,
                                    "fallback-url": slide.imageUrl,
                                    alt: slide.imageAltText,
                                  },
                                }),
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "home-slider__product-wrapper d-md-flex",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-5 home-slider__item-image",
                                  },
                                  [
                                    index === 1
                                      ? _c("img", {
                                          staticClass: "img-cover img-fluid",
                                          attrs: {
                                            src: slide.imageUrl,
                                            alt: slide.imageAltText,
                                          },
                                        })
                                      : _c("lazy-img", {
                                          attrs: {
                                            "picture-class":
                                              "img-cover img-fluid",
                                            "image-url": slide.imageUrl,
                                            "fallback-url": slide.imageUrl,
                                            alt: slide.imageAltText,
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 offset-xl-1 col-md-5 d-flex align-self-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "home-slider__item-infos",
                                      },
                                      [
                                        slide.customPrice || slide.prices
                                          ? _c(
                                              "div",
                                              { staticClass: "headline__92" },
                                              [
                                                _c("price-switch", {
                                                  attrs: {
                                                    prices: slide.prices,
                                                    "custom-price":
                                                      slide.customPrice,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "headline__62 text-primary mt-2 mb-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(slide.name) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text home-slider__text mb-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(slide.text) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-secondary home-slider__btn",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(slide.btntext) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "my-2",
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "14",
                                                  height: "18",
                                                },
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink",
                                                    "xlink:href": "#svg-arrow",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-scrollbar swiper-scrollbar--home" }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination swiper-pagination--home" }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "swiper-button-prev swiper-button-prev--home swiper-button-disabled",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-next swiper-button-next--home" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }